@if (isClearancesActive() && getMessageStatus() !== null) {
  <app-message-status
    [messageStatus]="getMessageStatus()"
    label="Port Authority" [reason]="getTooltipMessage"
    [header]="getTooltipHeader"></app-message-status>
}
